import { createClient } from '@supabase/supabase-js';

const supabaseUrl = import.meta.env.VITE_SUPABASE_URL;
const supabaseAnonKey = import.meta.env.VITE_SUPABASE_ANON_KEY;

export const supabase = createClient(supabaseUrl, supabaseAnonKey, {
  auth: {
    persistSession: true,
    autoRefreshToken: true,
    detectSessionInUrl: false,
    flowType: 'pkce',
    storage: {
      getItem: (key) => {
        const sessionValue = sessionStorage.getItem(key);
        return sessionValue || localStorage.getItem(key);
      },
      setItem: (key, value) => {
        localStorage.setItem(key, value);
        sessionStorage.setItem(key, value);
      },
      removeItem: (key) => {
        localStorage.removeItem(key);
        sessionStorage.removeItem(key);
      }
    }
  }
});

// Monitoramento de sessão
let sessionMonitorInterval: NodeJS.Timeout;

export const startSessionMonitoring = () => {
  sessionMonitorInterval = setInterval(async () => {
    try {
      const { data: { session }, error } = await supabase.auth.getSession();
      if (error || !session) return;
      
      const expiresAt = new Date(session.expires_at * 1000);
      const now = new Date();
      
      if (expiresAt.getTime() - now.getTime() < 900000) { // 15 minutos
        await supabase.auth.refreshSession();
      }
    } catch (error) {
      console.error('Session monitor error:', error);
    }
  }, 300000); // 5 minutos
};

export const stopSessionMonitoring = () => {
  if (sessionMonitorInterval) clearInterval(sessionMonitorInterval);
};

// Função de reconexão
export const forceReconnect = async () => {
  try {
    const { error: refreshError } = await supabase.auth.refreshSession();
    if (!refreshError) return { success: true };

    const { data: { session } } = await supabase.auth.getSession();
    if (session) return { success: true };

    // Testa uma consulta simples
    const { error: queryError } = await supabase
      .from('profiles')
      .select('id')
      .limit(1)
      .maybeSingle();

    return { success: !queryError, error: queryError?.message };
  } catch (error) {
    return { 
      success: false, 
      error: error instanceof Error ? error.message : 'Unknown error' 
    };
  }
};

// Inicia o monitoramento automaticamente
if (typeof window !== 'undefined') {
  startSessionMonitoring();
}